import React, { Component } from "react";
import PropTypes from "prop-types";

export default class AsyncField extends Component {
  static propTypes = {
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      onBlur: PropTypes.func.isRequired
    }).isRequired,
    check: PropTypes.func.isRequired,
    notify: PropTypes.func.isRequired,
    formComponent: PropTypes.func.isRequired,
    checkOnChange: PropTypes.bool
  };

  static defaultProps = {
    checkOnChange: false
  };

  onBlur = e => {
    const { input, check, checkOnChange } = this.props;

    input.onBlur(e.target.value);
    if (!checkOnChange) check(e.target.value);
  };

  onChange = e => {
    const { input, notify, check, checkOnChange } = this.props;

    input.onChange(e);

    if (checkOnChange) {
      check(e.target.value);
    } else {
      notify();
    }
  };

  render() {
    const { input, formComponent: FormComponent, ...rest } = this.props;

    const field = { ...input, onBlur: this.onBlur, onChange: this.onChange };

    return <FormComponent input={field} {...rest} />;
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/AsyncField/AsyncField.jsx